import { authResponseProps } from './properties'

export const clearAuthData = state => {
    state.authResponse = JSON.parse(JSON.stringify(authResponseProps))
}

export const setAlert = (state, payload) => {
    
    document.getElementById('snackbarid').click()
    
    state.alert.show = true
    state.alert.message = payload.message
}

export const showAuthModal = (state, payload) => {
    state.authModal.show = true
    state.authModal.admin = payload.admin
    state.authModal.title = payload.admin == 0 ? 'message.authenticateAsAdmin' : 'message.authenticate'
    state.authModal.target =  payload.target
    state.authModal.targetParameters = payload.targetParameters
}

export const setAuthDialogOff = state => {
    state.authModal.show = false
    state.authModal.admin = 0
    state.authModal.title = ''
    state.authModal.target =  ''
    state.authModal.targetParameters = []
}

export const setUserauthResponse = (state, payload) => {

    state.authResponse = payload
    
}

export const setAlertBox = (state, payload) => {
    state.alertBox.show = true
    state.alertBox.title = payload.title
    state.alertBox.message = payload.message
}

export const setConfirmBox = (state, payload) => {
    state.confirmBox.show = true
    state.confirmBox.title = payload.title
    state.confirmBox.message = payload.message
    state.confirmBox.followingAction = payload.followingAction
}

export const setConfirmBoxOff = state => {
    state.confirmBox.show = false    
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js